import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectUnselectedPlantsDuringAdviceWithImpact,
  addSelectedPlantId,
  addSelectedPlantIds,
} from '../../../../ducks/plants';
import FilterableList, { filterTypesEnum } from '../../../../components/FilterableList';
import { plantFiltersAdvice } from '../../../../utils/filters';
import { plantSelectionTypesEnum } from '../../../../ducks/plants/types';
import {
  getAdvice,
  getFloweringArch, selectAdviceIsLoading,
} from '../../../../ducks/floweringArch';
import { floweringArchTypesEnum } from '../../../../ducks/floweringArch/types';
import SubjectCard from '../../../../components/SubjectCard';
import {
  booleanText, parseCopyRightText,
  parseTrueFalseNullText,
} from '../../../../utils/valuesToHumanReadable';
import {
  helpTextPlantPresentAccordingToModel,
  helpTextPlantPresentAccordingToUser,
} from '../../../../utils/text';

const extraPlantFilters = {
  ...plantFiltersAdvice,
  id: {
    label: 'Filter beplanting voor',
    filterType: filterTypesEnum.isRelevant,
    value: null,
  },
};

const SelectPlants = () => {
  const dispatch = useDispatch();
  const unselectedPlants = useSelector(selectUnselectedPlantsDuringAdviceWithImpact);
  const adviceIsLoading = useSelector(selectAdviceIsLoading);

  return (
    <FilterableList
      isLoading={adviceIsLoading}
      filterConfig={extraPlantFilters}
      data={unselectedPlants}
      searchableByProperties={['dutchName', 'scientificName']}
      quickSelect={{
        handleSelectResults: (results) => {
          const ids = results.map((result) => result.id);
          dispatch(addSelectedPlantIds({
            selectionType: plantSelectionTypesEnum.pickedFromAdviceIds,
            plantIds: ids,
          }));
          dispatch(getAdvice());
          dispatch(getFloweringArch(floweringArchTypesEnum.basedOnAdvise));
        },
      }}
      render={(filteredData) => filteredData.map((plant) => (
        <SubjectCard
          key={plant.id}
          md={6}
          lg={4}
          title={plant.dutchName}
          subtitle={plant.scientificName}
          imagePath={plant.imagePath}
          copyrightText={parseCopyRightText(plant)}
          propertiesToList={[
            {
              key: 'Als reeds aanwezig aangeduid',
              help: helpTextPlantPresentAccordingToUser,
              value: parseTrueFalseNullText(plant.isPresentAccordingToUser),
            },
            {
              key: 'Gemodelleerd in jouw gebied',
              help: helpTextPlantPresentAccordingToModel,
              value: booleanText(plant.isPresentAccordingToModel),
            },
          ]}
          ranges={plant.floweringMonths}
          impact={`+${plant.impact}% gemiddelde voedseldekking`}
          rangesHeading="Bloeitijd"
          handleClick={() => {
            dispatch(addSelectedPlantId({
              selectionType: plantSelectionTypesEnum.pickedFromAdviceIds,
              plantId: plant.id,
            }));
            dispatch(getAdvice());
            dispatch(getFloweringArch(floweringArchTypesEnum.basedOnAdvise));
          }}
        />
      ))}
    />
  );
};

export default SelectPlants;
